/** Espelha tipo_divergencia_compra (db_compras) e `TipoDivergenciaCompraEnum` da API Compras: tipo do problema registrado na conferência física. */
export enum TipoDivergenciaCompraEnum {
  Quantidade = 1,
  Avaria = 2,
}
